import React, { useEffect, useState } from "react";
import { Form, Row, Col, Button } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { useNavigate, useParams, Link } from "react-router-dom";
import { toast } from "react-hot-toast";
import { getHoliday, updateHoliday } from "../../store/slices/holiday";
import {
  FiHome,
  FiChevronRight,
} from "react-icons/fi";

export default function EditHoliday() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();

  const [formData, setFormData] = useState({
    name: "",
    fromDate: "",
    toDate: "",
  });

  const [errors, setErrors] = useState({});

  //   fetch edit data
  useEffect(() => {
    if (id) {
      const item = { id };
      dispatch(getHoliday(item))
        .unwrap()
        .then((res) => {
          const matchedHoliday = res?.data[0];
          if (matchedHoliday) {
            setFormData({
              name: matchedHoliday.name || "",
              fromDate: matchedHoliday.fromDate
                ? matchedHoliday.fromDate.split("T")[0]
                : "",
              toDate: matchedHoliday.toDate
                ? matchedHoliday.toDate.split("T")[0]
                : "",
            });
          }
        })
        .catch((err) => {
          console.error(err);
          toast.error(
            err?.response?.data?.message ||
            err?.message ||
            "Failed to fetch holiday "
          );
        });
    }
  }, [id, dispatch]);

  // ----------------> handlers <----------------
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    setErrors((prev) => ({ ...prev, [name]: "" }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    let newErrors = {};

    // Required field validation
    if (!formData.name.trim()) {
      newErrors.name = "Enter holiday name";
    }

    if (!formData.fromDate) {
      newErrors.fromDate = "Select from date";
    }

    if (!formData.toDate) {
      newErrors.toDate = "Select to date";
    }

    // Date validation
    if (formData.fromDate && formData.toDate) {
      const fromDate = new Date(formData.fromDate);
      const toDate = new Date(formData.toDate);

      fromDate.setHours(0, 0, 0, 0);
      toDate.setHours(0, 0, 0, 0);

      const today = new Date();
      today.setHours(0, 0, 0, 0);



      if (toDate < fromDate) {
        newErrors.toDate = "To Date must be same or after From Date";
      }
    }

    setErrors(newErrors);
    if (Object.keys(newErrors).length > 0) return;

    const payload = {
      id,
      name: formData.name,
      fromDate: formData.fromDate,
      toDate: formData.toDate,
    };

    dispatch(updateHoliday(payload))
      .unwrap()
      .then(() => {
        toast.success("Holiday updated successfully ");
        navigate("/institute/holidays");
      })
      .catch((err) => {
        toast.error(
          err?.response?.data?.message ||
          err?.message ||
          "Failed to update holiday "
        );
      });
  };

  // date validation

  const today = new Date();
  today.setMinutes(today.getMinutes() - today.getTimezoneOffset());

  const minDate = new Date(today);
  minDate.setFullYear(today.getFullYear() - 1);

  const maxDate = new Date(today);
  maxDate.setFullYear(today.getFullYear() + 1);

  const minDateStr = minDate.toISOString().split("T")[0];
  const maxDateStr = maxDate.toISOString().split("T")[0];

  return (
    <>
      <div className="page-header">
        <div className="breadcrumb-section">

          <div className="breadcrumb-left">
            <div className="home-icon">
              <Link to="/institute/home"><FiHome style={{ color: "white", marginTop: "-4px" }} /></Link>
            </div>

            <FiChevronRight className="separator" />

            <Link to="/institute/holidays">Holiday</Link>

            <FiChevronRight className="separator" />

            <span className="active">Edit Holiday</span>
          </div>

        </div>
      </div>
      <div className="acs-card">
        <Form onSubmit={handleSubmit}>
          <Row className="g-3">
            {/* Holiday Name */}
            <Col lg={4} md={6} sm={12}>
              <Form.Group>
                <Form.Label>Holiday Name</Form.Label>
                <Form.Control
                  type="text"
                  name="name"
                  placeholder="Enter holiday name"
                  value={formData.name}
                  onChange={handleChange}
                />
                {errors.name && (
                  <small className="text-danger">{errors.name}</small>
                )}
              </Form.Group>
            </Col>

            {/* From Date */}
            <Col lg={4} md={6} sm={12}>
              <Form.Group>
                <Form.Label>From Date</Form.Label>
                <Form.Control
                  type="date"
                  name="fromDate"
                  value={formData.fromDate}
                  min={minDateStr}
                  max={maxDateStr}
                  onChange={handleChange}
                />
                {errors.fromDate && (
                  <small className="text-danger">{errors.fromDate}</small>
                )}
              </Form.Group>
            </Col>

            {/* To Date */}
            <Col lg={4} md={6} sm={12}>
              <Form.Group>
                <Form.Label>To Date</Form.Label>
                <Form.Control
                  type="date"
                  name="toDate"
                  value={formData.toDate}
                  min={formData.fromDate || minDateStr}
                  max={maxDateStr}
                  onChange={handleChange}
                />
                {errors.toDate && (
                  <small className="text-danger">{errors.toDate}</small>
                )}
              </Form.Group>
            </Col>
          </Row>

          {/* Actions */}
          <div className="ah-actions mt-5">
            <button
              className="btn-cancel"
              style={{ color: "black" }}
              type="button"
              onClick={() => navigate(-1)}
            >
              Cancel
            </button>
            <button className="btn-submit" type="submit">
              Update
            </button>
          </div>
        </Form>
      </div>
    </>
  );
}
